export const LOGO_URL = "https://customer-assets.emergentagent.com/job_global-finance-hub-23/artifacts/ypr5bbur_5037EF77-DFBC-4DEA-AEEC-64A429CF41CE.png";
export const BRAND_NAME = "Tolulope Bello";
export const BRAND_SUB = "Wealth Builder Hub";

export const MARKETS = [
  { id: "Global", label: "Global", flag: "🌐" },
  { id: "US", label: "United States", flag: "🇺🇸" },
  { id: "UK", label: "United Kingdom", flag: "🇬🇧" },
  { id: "Canada", label: "Canada", flag: "🇨🇦" },
  { id: "Nigeria", label: "Nigeria", flag: "🇳🇬" },
  { id: "Africa", label: "Africa", flag: "🌍" },
  { id: "Europe", label: "Europe", flag: "🇪🇺" },
  { id: "Asia", label: "Asia", flag: "🌏" },
  { id: "Australia", label: "Australia", flag: "🇦🇺" },
];

export const CATEGORIES = [
  { id: "stocks", label: "Stocks", desc: "Deep AI company research", icon: "TrendingUp", path: "/research/stocks" },
  { id: "etfs", label: "ETFs", desc: "Exchange-traded fund breakdowns", icon: "Layers", path: "/research/etfs" },
  { id: "mutual", label: "Mutual Funds", desc: "Managed fund analysis", icon: "PieChart", path: "/research/mutual" },
  { id: "money_market", label: "Money Market", desc: "Cash & emergency fund options", icon: "Landmark", path: "/research/money-market" },
  { id: "compare", label: "Compare", desc: "Companies across countries", icon: "GitCompareArrows", path: "/compare" },
  { id: "portfolio", label: "Portfolio Analyzer", desc: "Check your diversification & risk", icon: "Wallet", path: "/portfolio" },
  { id: "chat", label: "AI Assistant", desc: "Ask anything about investing", icon: "Bot", path: "/chat" },
  { id: "academy", label: "Academy", desc: "Learn investing basics", icon: "GraduationCap", path: "/academy" },
  { id: "calculator", label: "Emergency Fund", desc: "Calculate your safety net", icon: "ShieldCheck", path: "/emergency-fund" },
];

export const COUNTRY_FLAGS = {
  "United States": "🇺🇸", "United Kingdom": "🇬🇧", "Canada": "🇨🇦", "Nigeria": "🇳🇬",
  "South Africa": "🇿🇦", "Egypt": "🇪🇬", "Kenya": "🇰🇪", "France": "🇫🇷", "Germany": "🇩🇪",
  "Switzerland": "🇨🇭", "Netherlands": "🇳🇱", "Italy": "🇮🇹", "Spain": "🇪🇸",
  "South Korea": "🇰🇷", "Japan": "🇯🇵", "Hong Kong": "🇭🇰", "China": "🇨🇳",
  "Singapore": "🇸🇬", "India": "🇮🇳", "Australia": "🇦🇺",
};

export function flagFor(country) {
  return COUNTRY_FLAGS[country] || "🌐";
}
